<template>
    <div class="language-selection">
        <form @submit.prevent>
            <label for="language">
                <app-icon
                    name="world"
                    :aria-label="$snippet('update_language', 'Update language')"
                />
            </label>

            <b-form-select
                id="language"
                name="language"
                :options="localeOptions"
                v-model="currentLocale"
                size="sm"
            />
        </form>
    </div>
</template>

<script>
    import { BFormSelect } from 'bootstrap-vue';
    import { mapState, mapGetters } from 'vuex';

    export default {
        name: 'language-selection',

        components: { BFormSelect },

        computed: {
            ...mapState('locales', [
                'locale',
                'pageLocales',
            ]),

            ...mapGetters('locales', [
                'pageLocalesWithName',
            ]),

            /**
             * Return the options for the select.
             *
             * @returns {{text: string, value: string}[]}
             */
            localeOptions() {
                return this.pageLocalesWithName.map(({ name, uri }) => ({
                    text: name,
                    value: uri,
                }));
            },

            currentLocale: {
                get() {
                    return this.$route.path;
                },

                set(localePath) {
                    // Make sure this doesn't throw in tests
                    if (localePath === this.$route.path) {
                        return;
                    }

                    this.$router.push(localePath);
                },
            },
        },
    };
</script>

<style lang="scss" scoped>
    ::v-deep {
        @import "~bootstrap/scss/custom-forms";
    }

    form {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    label {
        margin-bottom: 0;
        color: $itsu-primary;
    }

    .custom-select-sm {
        width: auto;
    }
</style>
